// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2FClf","messages":"Chat_messages__2TRdS","dateDivider":"Chat_dateDivider__hEv8T"};